import { ConfigDto, SampleDetailsDto } from '@src/types/types.ts';
import { AnySection } from '@src/asbestos/components/AnySection.tsx';
import { AsbestosTargetType } from '@src/asbestos/types.ts';

type SectionProps = {
  sample: SampleDetailsDto;
  configuration: ConfigDto;
  onInfoTap: () => void;
};

export const AsbestosSection = ({
  sample,
  configuration,
  onInfoTap,
}: SectionProps) => {
  return (
    <AnySection
      sample={sample}
      configuration={configuration}
      onInfoTap={onInfoTap}
      targetType={AsbestosTargetType.ASB}
    />
  );
};
